import React, { useContext, useEffect, useState } from 'react'
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import DailyPujaBookingBannerImg from "../../assets/images/new/DailyPoojaBookingBannerImg.png";
import { GetPujaOrderListByUserIDList, PujaDetailsBySlug } from '../../ApiServices/Puja/PujaApi';
import { LoaderContext } from '../../AuthContext/AuthContext';
import { t } from 'i18next';

import PanditBookingImg from "../../assets/images/new/BookPujaOrder.png";
import eStoreImg from "../../assets/images/new/estoreOrder.png";

import darshanImg from "../../assets/images/new/darshanBookingOrder.png";
import worshipImg from "../../assets/images/new/pujaAtTempleOrder.png";
import banner from '../../assets/images/new/orderPageBanner.png'
import pujaKitOrder from '../../assets/images/new/pujaKitOrder.png'
import prasadOrder from '../../assets/images/new/prasadOrder.png'
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BaseUrl } from '../../BaseUrl/BaseUrl';
import NoResultFoundModel from '../../Components/NoDataFound/NoDataFoundModal';
import { pujaServiceID, pujaSubServiceID } from '../../Components/enum';
import { GetProductBookingList, GetProductSubPackageOrderListByUserID } from '../../ApiServices/EStore/EStoreApi';
import { GetTempleDarshanBookingList } from '../../ApiServices/Temple Darshan Booking/TempleDarshanBookingApi';

import DailyPandit from '../../assets/images/new/Dailypandit.png'
import RemedyPuja from '../../assets/images/new/RemedyPuja.png'
import sankalpPuja from '../../assets/images/new/sankalparemedypuja.png'
import sankalpahomampuja from '../../assets/images/new/sankalpahomampuja.png'
import Ecommerce from '../../assets/images/new/E-commerce.png'
import TermplePuja from '../../assets/images/new/TermplePuja.png'

const services = [
    {
        id: 3,
        title: t("Remedy Puja"),
        route: "/order-details",
        img: RemedyPuja,
    },
    {
        id: 4,
        title: t("Homam Puja"),
        route: "/order-details",
        img: sankalpahomampuja,
    },
    {
        id: 1,
        title: t("Pandit Booking"),
        route: "/order-details",
        img: PanditBookingImg,
    },
    {
        id: 2,
        title: t("Daily Pandit (Puja)"),
        route: "/order-details",
        img: DailyPandit,
    },



    {
        id: 5,
        title: t("Subscription Remedy Puja"),
        route: "/order-details",
        img: sankalpPuja,
    },
    {
        id: 6,
        title: t("Subscription Homam Puja"),
        route: "/order-details",
        img: sankalpahomampuja,
    },
    {
        id: 7,
        title: t("Puja At Temple"),
        route: "/order-details",
        img: darshanImg,
    },
    {
        id: 8,
        title: t("E-Store"), route: "/product-order-details", img: Ecommerce
    },
    {
        id: 9,
        title: t("Prasad"), route: "/product-order-details", img: eStoreImg
    },
    {
        id: 10,
        title: t("Temple Darshan"), route: "/darshan-order-details", img: TermplePuja
    },
    // {
    //     id: 11,
    //     title: t("Puja Kit Subscription"), route: "/product-order-details", img: eStoreImg
    // },


]

const PujaOrderListPage = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const userKeyID = localStorage.getItem("userKeyID");

    const [totalRecords, setTotalRecords] = useState(-1);
    const { setLoader, selectedLanguageID, formatToIndianCurrency, isLanguageUpdate } = useContext(LoaderContext);
    const [pageSize, setPageSize] = useState(50)

    const [orderList, setOrderList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [prasadList, setPrasadList] = useState([]);
    const [categories, setCategories] = useState([])

    const [selectedCategory, setSelectedCategory] = useState(null)
    const [isCatUpdated, setIsCatUpdated] = useState(false)
    const [pageHeading, setPageHeading] = useState("My Orders")



    useEffect(() => {

        if (location?.state?.pujaType !== null && location?.state?.pujaType !== undefined) {
            const selectedID = services?.filter((prev) => prev.id === location?.state?.pujaType)
            setSelectedCategory(selectedID[0]?.id)
        } else {
            setSelectedCategory(3)
        }
    }, [])

    useEffect(() => {

        const DetailsRoute = services?.filter((prev) => prev.id === selectedCategory)
        setPageHeading(t(DetailsRoute[0]?.title))
        setOrderList([])
        setTotalRecords(-1)
        if (selectedCategory === 1) {
            GetPujaOrderListByUserIDListData(pujaServiceID?.PanditPuja, pujaSubServiceID?.PanditPuja, 1)
        } else if (selectedCategory === 2) {
            GetPujaOrderListByUserIDListData(pujaServiceID?.PanditPuja, pujaSubServiceID?.DailyPanditPuja, 1)
        } else if (selectedCategory === 3) {
            GetPujaOrderListByUserIDListData(pujaServiceID?.Puja, pujaSubServiceID?.RemedyPuja, 1)
        } else if (selectedCategory === 4) {
            GetPujaOrderListByUserIDListData(pujaServiceID?.Puja, pujaSubServiceID?.HomamPuja, 1)
        } else if (selectedCategory === 5) {
            GetPujaOrderListByUserIDListData(pujaServiceID?.SankalpPuja, pujaSubServiceID?.SubscriptionRemedyPuja, 1)
        } else if (selectedCategory === 6) {
            GetPujaOrderListByUserIDListData(pujaServiceID?.SankalpPuja, pujaSubServiceID?.SubscriptionHomamPuja, 1)
        } else if (selectedCategory === 7) {
            GetPujaOrderListByUserIDListData(pujaServiceID?.Temple, pujaSubServiceID?.PujaAtTemple, 1)
        } else if (selectedCategory === 8) {
            GetProductBookingListData(1)
        } else if (selectedCategory === 9) {
            GetProductBookingListData(1)
        } else if (selectedCategory === 10) {
            GetTempleDarshanBookingListData(1)
        } else if (selectedCategory === 11) {
            GetProductSubPackageOrderListByUserIDData(1)
        }

    }, [selectedCategory, isLanguageUpdate]);


    const GetPujaOrderListByUserIDListData = async (pujaServiceID, pujaSubServiceID, pageNumber) => {

        setLoader(true);
        try {
            const response = await GetPujaOrderListByUserIDList({
                pageSize: pageSize,
                pageNo: pageNumber - 1,
                pujaServiceID: pujaServiceID,
                pujaSubServiceID: pujaSubServiceID
            }, userKeyID, selectedLanguageID);

            if (response?.statusCode === 200) {
                setLoader(false);
                const list = response?.responseData?.data || []
                setOrderList(list);
                setTotalRecords(list?.length);
                setIsCatUpdated(true)

            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const GetProductBookingListData = async (pageNumber) => {

        setLoader(true);
        try {
            const response = await GetProductBookingList({
                pageSize: pageSize,
                pageNo: pageNumber - 1,
                sortingDirection: null,
                sortingColumnName: null,
                searchKeyword: null,
                fromDate: null,
                toDate: null
            }, userKeyID, selectedLanguageID);

            if (response?.statusCode === 200) {
                setLoader(false);
                const list = response?.responseData?.data || []
                // setPrasadList(list);
                selectedCategory === 8 ? setOrderList(list?.productList) : setOrderList(list?.prasadList);
                selectedCategory === 8 ? setTotalRecords(list?.productList?.length) : setTotalRecords(list?.prasadList?.length);


                setIsCatUpdated(true)

            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const GetTempleDarshanBookingListData = async (pageNumber) => {

        setLoader(true);
        try {
            const response = await GetTempleDarshanBookingList({
                pageSize: pageSize,
                pageNo: pageNumber - 1,
                searchKeyword: null,
                fromDate: null,
                toDate: null,
                userKeyID: userKeyID,
                appLangID: Number(selectedLanguageID)
            });

            if (response?.statusCode === 200) {
                setLoader(false);
                const list = response?.responseData?.data || []
                // setPrasadList(list);
                setOrderList(list);
                setTotalRecords(list?.length);
                // setIsCatUpdated(true)


            } else {
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };
    const GetProductSubPackageOrderListByUserIDData = async (pageNumber) => {

        setLoader(true);
        try {
            const response = await GetProductSubPackageOrderListByUserID(
                {
                    pageSize: pageSize,
                    pageNo: pageNumber - 1,
                    searchKeyword: null,
                    fromDate: null,
                    toDate: null,
                    userKeyID: userKeyID,
                    appLangID: Number(selectedLanguageID)
                }, userKeyID, Number(selectedLanguageID));

            if (response?.statusCode === 200) {
                setLoader(false);
                const list = response?.responseData?.data || []
                // setPrasadList(list);
                setOrderList(list);
                setTotalRecords(list?.length);
                // setIsCatUpdated(true)


            } else {
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };



    const orderDetails = (orders) => {

        const DetailsRoute = services?.filter((prev) => prev.id === selectedCategory)
        navigate(`${DetailsRoute[0]?.route}`, { state: { order: orders, id: selectedCategory } });
    }


    // ----------------------UI Functions ----------------------------------------

    const panditBookingList = () => {
        return (
            <>
                <div className="row g-2 mt-1" style={{ maxHeight: "100vh", overflowY: "auto", scrollbarWidth: "none", justifyContent: "left" }}>
                    {orderList?.map((puja, index) => (
                        <div className="col-xl-4 col-lg-4 col-md-6" key={puja.id}>
                            <div
                                className="card  shadow-lg h-100 order-detailmain"
                                onClick={() => orderDetails(puja)}
                                style={{
                                    cursor: "pointer",
                                    padding: "0px 12px 0px 10px",
                                    border: "3px solid #ec9e2a4d ",
                                }}
                            >
                                <h6
                                    className="mb-1 text-center"
                                    style={{
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        fontSize: "15px",
                                        backgroundColor: "#ec9e2a4d",
                                        padding: "6px 10px",
                                        marginBottom: "20px",
                                        color: "#a42642",
                                        fontWeight: "600",
                                        borderRadius: "0px 0px 51px 51px",
                                    }}
                                    title={puja.pujaName}
                                >
                                    {puja.pujaName}
                                </h6>

                                <div
                                    className="d-flex align-items-start"
                                    style={{
                                        marginTop: "12px",
                                        marginBottom: "10px",
                                    }}
                                >
                                    <img
                                        src={puja?.pujaImageUrl || pandit}
                                        alt={puja.pujaName}
                                        className="rounded me-2"
                                        style={{ width: "100px", height: "100px", objectFit: "contain" }}
                                    />
                                    <div >

                                        <span className="fw-bold text-muted" style={{ fontSize: "12px" }}>#{puja.bookingID}</span>
                                        <p className="mb-1" style={{ fontSize: "12px" }}><strong>Booking Date:</strong> {puja.bookingDate}</p>
                                        {/* <p className="mb-1" style={{ fontSize: "12px" }}><strong>{t("Puja Type")}:</strong> {t(puja.pujaType || "Offline")}</p> */}
                                        <p className="mb-1" style={{ fontSize: "12px" }}>
                                            <strong>{t("Payment Status")}:</strong>{" "}
                                            <span
                                                style={{
                                                    color: puja.paymentStatus === "Pending" ? "red" : "green",
                                                    fontWeight: "600", fontSize: "12px"
                                                }}
                                            >
                                                {puja.paymentStatus === "Complete"
                                                    ? t("Completed")
                                                    : t(puja.paymentStatus)}

                                            </span>
                                        </p>
                                        <p className="mb-1 fw-bold" style={{ fontSize: "12px" }}>
                                            {t("Total Amount")}: ₹ {formatToIndianCurrency(Math.round(puja?.totalAmount))}
                                        </p>

                                    </div>
                                </div>
                                <div className="service-two__item__rm" onClick={() => orderDetails(puja)}>
                                    <span style={{ color: '#a52444', fontWeight: '600' }}>
                                        {t("View Details")}
                                    </span>
                                    <i className="icon-right-arrow"></i>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </>
        )
    }

    const ProductBookingList = () => {
        return (
            <>
                <div className="row g-2 mt-1" style={{ maxHeight: "100vh", overflowY: "auto", scrollbarWidth: "none", justifyContent: "left" }}>
                    {orderList?.map((puja, index) => (
                        <div className="col-xl-4 col-lg-4 col-md-6" key={puja.id}>
                            <div
                                className="card  shadow-lg h-100 order-detailmain"
                                onClick={() => orderDetails(puja)}
                                style={{
                                    cursor: "pointer",
                                    padding: "0px 12px 0px 10px",
                                    border: "3px solid #ec9e2a4d ",
                                }}
                            >
                                <h6
                                    className="mb-1 text-center"
                                    style={{
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        fontSize: "15px",
                                        backgroundColor: "#ec9e2a4d",
                                        padding: "6px 10px",
                                        marginBottom: "20px",
                                        color: "#a42642",
                                        fontWeight: "600",
                                        borderRadius: "0px 0px 51px 51px",
                                    }}
                                    title={puja.productName}
                                >
                                    {puja.productName}
                                </h6>

                                <div
                                    className="d-flex align-items-start"
                                    style={{
                                        marginTop: "12px",
                                        marginBottom: "10px",
                                    }}
                                >
                                    <img
                                        src={puja?.productImageURL || pandit}
                                        alt={puja.productName}
                                        className="rounded me-2"
                                        style={{ width: "100px", height: "100px", objectFit: "contain" }}
                                    />
                                    <div >

                                        <span className="fw-bold text-muted" style={{ fontSize: "12px" }}>#{puja.bookingID}</span>
                                        {/* <p className="mb-1"><strong>Puja Date:</strong> {puja.PB_DATE}</p> */}
                                        {/* <p className="mb-1" style={{ fontSize: "12px" }}><strong>{t("Puja Type")}:</strong> {t(puja.pujaType || "Offline")}</p> */}
                                        <p className="mb-1" style={{ fontSize: "12px" }}>
                                            <strong>{t("Payment Status")}:</strong>{" "}
                                            <span
                                                style={{
                                                    color: puja.paymentStatus === "Pending" ? "red" : "green",
                                                    fontWeight: "600", fontSize: "12px"
                                                }}
                                            >
                                                {puja.paymentStatus === "Complete"
                                                    ? t("Completed")
                                                    : t(puja.paymentStatus)}

                                            </span>
                                        </p>
                                        <p className="mb-1 fw-bold" style={{ fontSize: "12px" }}>
                                            {t("Total Amount")}: ₹ {formatToIndianCurrency(Math.round(puja?.grandTotal))}
                                        </p>

                                    </div>
                                </div>
                                <div className="service-two__item__rm" onClick={() => orderDetails(puja)}>
                                    <span style={{ color: '#a52444', fontWeight: '600' }}>
                                        {t("View Details")}
                                    </span>
                                    <i className="icon-right-arrow"></i>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </>
        )
    }

    const DarshanBookingList = () => {
        return (
            <>
                <div className="row g-2 mt-1" style={{ maxHeight: "100vh", overflowY: "auto", scrollbarWidth: "none", justifyContent: "left" }}>
                    {orderList?.map((puja, index) => (
                        <div className="col-xl-4 col-lg-4 col-md-6" key={puja.id}>
                            <div
                                className="card  shadow-lg h-100 order-detailmain"
                                onClick={() => orderDetails(puja)}
                                style={{
                                    cursor: "pointer",
                                    padding: "0px 12px 0px 10px",
                                    border: "3px solid #ec9e2a4d ",
                                }}
                            >
                                <h6
                                    className="mb-1 text-center"
                                    style={{
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        fontSize: "15px",
                                        backgroundColor: "#ec9e2a4d",
                                        padding: "6px 10px",
                                        marginBottom: "20px",
                                        color: "#a42642",
                                        fontWeight: "600",
                                        borderRadius: "0px 0px 51px 51px",
                                    }}
                                    title={puja.templeDarshanName}
                                >
                                    {puja.templeDarshanName}
                                </h6>

                                <div
                                    className="d-flex align-items-start"
                                    style={{
                                        marginTop: "12px",
                                        marginBottom: "10px",
                                    }}
                                >
                                    <img
                                        src={puja?.productImageURL || pandit}
                                        alt={puja.templeDarshanName}
                                        className="rounded me-2"
                                        style={{ width: "100px", height: "100px", objectFit: "contain" }}
                                    />
                                    <div >

                                        <span className="fw-bold text-muted" style={{ fontSize: "12px" }}>#{puja.bookingID}</span>
                                        <p className="mb-1" style={{ fontSize: "12px" }}><strong>Booking Date:</strong> {puja.createdOnDate}</p>
                                        {/* <p className="mb-1" style={{ fontSize: "12px" }}><strong>{t("Puja Type")}:</strong> {t(puja.pujaType || "Offline")}</p> */}
                                        <p className="mb-1" style={{ fontSize: "12px" }}>
                                            <strong>{t("Payment Status")}:</strong>{" "}
                                            <span
                                                style={{
                                                    color: puja.paymentStatus === "Pending" ? "red" : "green",
                                                    fontWeight: "600", fontSize: "12px"
                                                }}
                                            >
                                                {puja.paymentStatus === "Complete"
                                                    ? t("Completed")
                                                    : t(puja.paymentStatus)}

                                            </span>
                                        </p>
                                        <p className="mb-1 fw-bold" style={{ fontSize: "12px" }}>
                                            {t("Total Amount")}: ₹ {formatToIndianCurrency(Math.round(puja?.totalAmount || 0))}
                                        </p>

                                    </div>
                                </div>
                                <div className="service-two__item__rm" onClick={() => orderDetails(puja)}>
                                    <span style={{ color: '#a52444', fontWeight: '600' }}>
                                        {t("View Details")}
                                    </span>
                                    <i className="icon-right-arrow"></i>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </>
        )
    }



    return (
        <>
            <section className="page-header">
                <div className="page-header__bg" style={{ backgroundImage: `url(${DailyPujaBookingBannerImg})` }}></div>
                <div className="container" >
                    <h2 className="page-header__title bw-split-in-left">{`${pageHeading} ${t("Orders")}`}</h2>
                </div>
            </section>
            <div className="container-fluid my-4">
                {/* -------- Mobile View: Horizontal Categories -------- */}
                <fieldset className="border rounded mb-3 d-block d-md-none">
                    <legend className="float-none w-auto px-2 fw-bold" style={{ fontSize: "14px" }}>
                        {t("categories")}
                    </legend>
                    <div className="d-block d-md-none">
                        <div
                            className="d-flex gap-1 overflow-auto"
                            style={{ whiteSpace: "nowrap", scrollbarWidth: 'none' }}
                        >
                            {services?.map((cat) => (
                                <li key={cat.id} className="mb-2">
                                    <label
                                        className={`d-flex align-items-center gap-2 form-check-label small ${selectedCategory === cat.id ? "activeText" : ""
                                            }`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setSelectedCategory(cat.id)}
                                    >
                                        <img
                                            src={cat.img}
                                            alt={cat.title}
                                            className="rounded-circle border"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                objectFit: "cover", // ensures the image fills the circle
                                            }}
                                        />
                                        <span>{cat.title}</span>
                                    </label>
                                </li>
                            ))}
                        </div>
                    </div>
                </fieldset>

                <div className="row">
                    {/* -------- Desktop Sidebar -------- */}
                    <aside className="col-md-3 d-none d-md-block">
                        <fieldset className="border rounded mb-3">
                            <legend
                                className="float-none w-auto px-2 fw-bold"
                                style={{ fontSize: "16px" }}
                            >
                                {t("Services")}
                            </legend>

                            <div
                                className="p-3"
                                style={{ maxHeight: "80vh", overflowY: "auto", scrollbarWidth: "none" }}
                            >
                                <ul className="list-unstyled m-0" style={{ cursor: 'pointer' }}>
                                    {services?.map((cat) => (
                                        <li key={cat.id} className="mb-2">
                                            <label
                                                className={`d-flex align-items-center gap-2 fw-bold small ${selectedCategory === cat.id ? "activeText" : ""
                                                    }`}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => setSelectedCategory(cat.id)}
                                            >
                                                <img
                                                    src={cat.img}
                                                    alt={cat.title}
                                                    className="rounded-circle border"
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        objectFit: "cover", // ensures the image fills the circle
                                                    }}
                                                />
                                                <span className={`${selectedCategory === cat.id ? "fw-bold" : ''}`}>{t(cat.title)}</span>
                                            </label>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </fieldset>
                    </aside>

                    {/* -------- Puja Grid -------- */}
                    <main className="col-md-9 col-12">
                        {selectedCategory <= 7 ? panditBookingList() : ''}
                        {(selectedCategory === 8 || selectedCategory === 9 || selectedCategory === 11) ? ProductBookingList() : ''}
                        {(selectedCategory === 10) ? DarshanBookingList() : ''}

                        {totalRecords <= 0 && <NoResultFoundModel totalRecords={totalRecords} moduleName="orderPage" />}
                    </main>

                </div>
            </div>

        </>
    )
}

export default PujaOrderListPage
